import React from 'react';
import { connect } from 'react-redux';
import { adminIsLoadedSelector, policiesSelector } from '../selectors';
import { websiteSelector } from 'common/selectors';
import { adminIsLoadingAction, adminSetPoliciesAction, adminUpdatePoliciesRequestAction } from '../actions';
import { rebuildPolicies, unTokenizePolicies } from '../utils';
import { policyModel } from 'common/api/models';
import { AdminLayoutView } from './view';

export const PermissionElementAttrEnum = class {
  static POLICY_ID = 'data-policy-id';
  static POLICY_NAME = 'data-policy-name';
  static PERMISSION_NAME = 'data-permission-name';
};

export const AdminLayout = connect(
  (state) => ({
    policies: policiesSelector(state),
    website: websiteSelector(state),
    isAdminLoading: !adminIsLoadedSelector(state),
  }),
  (dispatch) => ({
    updatePolicies: (websiteId, policies) => dispatch(adminUpdatePoliciesRequestAction(policies, websiteId)),
    setPolicies: (policies) => dispatch(adminSetPoliciesAction(policies)),
    adminIsUpdating: (status) => dispatch(adminIsLoadingAction(status)),
  })
)(
  class extends React.Component {
    state = {
      isModalOpen: false,
    };

    openModal = () => this.setState({ isModalOpen: true });
    closePolicyModal = () => this.setState({ isModalOpen: false });

    onModalClose = (policyName) => {
      if (policyName) {
        this.props.setPolicies(rebuildPolicies(this.props.policies, policyModel({ organizationGroup: policyName })));
      }

      this.closePolicyModal();
    };

    saveState = () => {
      this.props.adminIsUpdating(true);
      this.props.updatePolicies(this.props.website.id, unTokenizePolicies(this.props.policies));
    };

    render() {
      return (
        <AdminLayoutView
          {...{
            isModalOpen: this.state.isModalOpen,
            onModalClose: this.onModalClose,
            openModal: this.openModal,
            saveState: this.saveState,
            showBlockUi: this.props.isAdminLoading,
          }}
        >
          {this.props.children}
        </AdminLayoutView>
      );
    }
  }
);
